const xeComVisuals = [
  {
    src: "/images/xe/case-studies/xe-com/01-desktop-home.jpg",
    alt: "XE.com desktop homepage with currency converter and live exchange rates",
    caption: "Desktop homepage and live rates",
  },
  {
    src: "/images/xe/case-studies/xe-com/02-desktop-converter.jpg",
    alt: "XE.com desktop currency converter experience",
    caption: "Desktop currency converter",
  },
  {
    src: "/images/xe/case-studies/xe-com/03-desktop-output.jpg",
    alt: "XE.com desktop conversion results page",
    caption: "Conversion results",
  },
  {
    src: "/images/xe/case-studies/xe-com/04-mobile-home.jpg",
    alt: "XE.com responsive mobile homepage",
    caption: "Responsive mobile homepage",
  },
  {
    src: "/images/xe/case-studies/xe-com/05-mobile-chart.jpg",
    alt: "XE.com mobile currency chart",
    caption: "Mobile currency chart",
  },
];

export default xeComVisuals;
